import React from "react"
import classes from "./Textarea.module.scss"

interface ITextareaProps {
  name: string
  label?: string
  value: string
  onChange?: any
  className?: string
  required?: boolean
  valid?: boolean
  shouldValidate?: boolean
  errorMessage?: string
  touched?: boolean
  rows?: number
}

function Textarea({label, className, valid, shouldValidate, touched, required, errorMessage, ...rest}: ITextareaProps) {

  const cls = [classes.wrap]

  if (className) {
    cls.push(className)
  }

  if (!valid && shouldValidate)
    cls.push(classes.error)

  if (required) {
    cls.push(classes.required)
  }

  const id = `textarea-${Math.random()}`
  const labelTemplate = label ? <label htmlFor={id}>{label}</label> : null

  const errorMessageTemplate = errorMessage && <span className={classes.error_message}>{errorMessage}</span>

  return (
    <div className={cls.join(" ")}>
      <div className={classes.container}>
        {labelTemplate}
        <textarea
          {...rest}
        />
      </div>
      {errorMessageTemplate}
    </div>
  )
}

export default Textarea